// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3Vkgn","expandIcon":"AccordionButton_expandIcon__WhQHs","expanded":"AccordionButton_expanded__y4M9K"};